import { addDisplayName, addHandlers, addState, flowMax } from 'ad-hok'
import { getContextHelpersFromInitialValues } from 'ad-hok-utils'
import { FC } from 'react'
import { LoginTrigger, addAuthContext } from 'shared/src/utils/auth'
import { typedAs } from 'shared/src/utils/typedAs'

interface ShowRegisterContext {
  showRegister: boolean
  setShowRegister: (show: boolean) => void
  toggleRegister: () => void
  showRegisterIfNotAuthenticated: (loginTrigger?: LoginTrigger) => boolean
  loginTrigger: LoginTrigger | undefined
  setLoginTrigger: (loginTrigger: LoginTrigger) => void
}

export const [addShowRegisterContextProvider, addShowRegisterContext] =
  getContextHelpersFromInitialValues<ShowRegisterContext>({
    showRegister: false,
    setShowRegister: () => {},
    toggleRegister: () => {},
    showRegisterIfNotAuthenticated: () => false,
    loginTrigger: undefined,
    setLoginTrigger: () => {},
  })

export const RegisterProvider: FC = flowMax(
  addDisplayName('RegisterProvider'),
  addState('showRegister', 'setShowRegister', false),
  addAuthContext,
  addState(
    'loginTrigger',
    'setLoginTrigger',
    typedAs<LoginTrigger | undefined>(undefined)
  ),
  addHandlers({
    toggleRegister:
      ({ showRegister, setShowRegister }) =>
      () => {
        setShowRegister(!showRegister)
      },
    showRegisterIfNotAuthenticated:
      ({ isAuthenticated, showRegister, setShowRegister, setLoginTrigger }) =>
      (loginTrigger?: LoginTrigger) => {
        if (!isAuthenticated && loginTrigger) {
          setLoginTrigger(loginTrigger)
        }
        if (!isAuthenticated && !showRegister) {
          setShowRegister(true)
          return true
        } else if (isAuthenticated && showRegister) setShowRegister(false)
        return false
      },
  }),
  addShowRegisterContextProvider,
  ({ children }) => <>{children}</>
)
